import React from 'react';
import { format } from 'date-fns';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';
// import { createStackNavigator, createAppContainer } from 'react-navigation';
// Material Components
import Hero from '../../components/Hero';
import SecondaryEatery from '../../components/SecondaryEatery';

import MainEatery from '../../components/MainEatery';
import ContributorCard from '../../components/ContributorCard';
import Card from '../../components/card/cardslide';
import BoostCard from '../../components/BoostCard';
import SeeAllContributors from '../../components/SeeAllContributors';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { storeCityName } from 'utils/';

const styles = theme => ({
  featuredContainer: {
    padding: '20px',
    textAlign: 'left',
  },
  relatedContainer: {
    marginTop: '-10px',
  },
  centering: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
});

class EateryPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentWillMount(){
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    let eateryname = this.props.match.params.eateryname;
    let cityname = this.props.match.params.cityname;
    this.props.dispatch(actions.getData(eateryname, cityname));
  }
  componentDidUpdate(prevProps) {
    let eateryname = this.props.match.params.eateryname;
    let cityname = this.props.match.params.cityname;
    if (eateryname !== prevProps.match.params.eateryname) {
      this.props.dispatch(actions.getData(eateryname, cityname));
    }
  }
  render() {
    const { classes, history, loading, eatery, related } = this.props;

    if (loading) {
      return <Loader />;
    } else {
      const currEatery = eatery.entity;
      const mainImage = currEatery.mainImage ? currEatery.mainImage : {};
      const owner = currEatery.owner ? currEatery.owner : {};
      const ownerID = owner.id ? owner.id : '';
      const mustTryTags = currEatery.mustTryDishes.dishes.map(tag => tag.name);
      const alsoServesTags = currEatery.alsoServes.dishes.map(tag => tag.name);
      const checkingCuisineExpt = owner.cuisinesOfExpertise ? owner.cuisinesOfExpertise : [];
      const cuisinesOfExpert = checkingCuisineExpt ? checkingCuisineExpt.map(cuis => cuis.name) : [];
      return (
        <div>
          <Hero
            {...{
              title: currEatery.name,
              lastUpdated: format(currEatery.updatedAt, 'MMM DD YYYY'),
              imageUrl: mainImage.uri,
              oneLiner: currEatery.summary,
            }}
          />
          <SecondaryEatery
            {...{
              mustTryTags,
              alsoServesTags,
              cuisinesTags: currEatery.cuisines,
              location: currEatery.location,
              history,
            }}
          />
          <MainEatery {...{ eateryData: eatery }} />
          {owner.displayName || owner.name ? (
            <ContributorCard
              {...{
                name: owner.displayName ? owner.displayName : owner.name,
                img: owner.profilePic
                  ? owner.profilePic.uri
                  : '/icons/user.png',
                oneLineDesc: owner.userProfile.bio ? owner.userProfile.bio : '',
                cuisines: cuisinesOfExpert ? cuisinesOfExpert : '',
                following: true,
                id: ownerID,
              }}
            />
          ) : (
              ''
            )}
          {
            eatery.contributions[0].owner ? (
              <SeeAllContributors contributors={eatery.contributions} />
            ) : (
                ''
              )
          }
          {eatery.comments[0].owner ? (
            <BoostCard comments={eatery.comments} />
          ) : (
              <BoostCard />
            )}
          <div className={classes.featuredContainer}>
            {/* TODO: temporary comment {featured.length > 0 ? (
              <Typography variant="body2">FEATURED</Typography>
            ) : (
              ' '
            )}
            <br />
            <Card history={history} cards={featured} />
            <br /> */}
            <br />
            <div className={classes.relatedContainer}>
              {related.length > 0 ? (
                <Typography variant="body2">RELATED</Typography>
              ) : (
                  ''
                )}
              <br />
            </div>
            <Card history={history} cards={related} />
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(EateryPage));
